const User = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M18 19C18 16.8522 15.3137 15.1111 12 15.1111C8.68629 15.1111 6 16.8522 6 19M12 12.7778C9.92893 12.7778 8.25 11.0367 8.25 8.88889C8.25 6.74111 9.92893 5 12 5C14.0711 5 15.75 6.74111 15.75 8.88889C15.75 11.0367 14.0711 12.7778 12 12.7778Z"
      stroke="#161E45"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default User;
